import { Collapsible_Button_default } from "./chunk-PVBAU22U.js";
import { CollapsibleContext } from "./chunk-P4FH6SY6.js";
import { Heading_default } from "./chunk-EXW7ZGG6.js";
import { Icon_default } from "./chunk-BTGG6N6L.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Collapsible/Collapsible.Header.tsx
import React, { useContext, useMemo, cloneElement } from "react";
import clsx from "clsx";
var CollapsibleHeader = _a => {
  var _b = _a,
    {
      title: titleProp,
      secondaryAction,
      children,
      button = /* @__PURE__ */React.createElement(Collapsible_Button_default, null),
      className
    } = _b,
    rest = __objRest(_b, ["title", "secondaryAction", "children", "button", "className"]);
  const {
    id
  } = useContext(CollapsibleContext);
  const title = useMemo(() => cloneElement(button, {
    children: titleProp
  }), [button, titleProp]);
  return /* @__PURE__ */React.createElement("header", __spreadProps(__spreadValues({}, rest), {
    className: clsx("pd-collapsible__header", className)
  }), /* @__PURE__ */React.createElement(Heading_default, {
    as: "span",
    variant: "display",
    size: "3",
    className: "pd-text-dim-800"
  }, title), /* @__PURE__ */React.createElement("div", {
    id: "".concat(id, "-subtitle"),
    className: "pd-grow"
  }, children), /* @__PURE__ */React.createElement("div", {
    className: "pd-grow-0 pd-flex pd-z-20 pd-text-dim-800"
  }, secondaryAction), /* @__PURE__ */React.createElement(Icon_default, {
    icon: "double-chevron-down",
    className: "pd-collapsible__chevron"
  }));
};
var Collapsible_Header_default = CollapsibleHeader;
export { Collapsible_Header_default };